//import '@master/css';
import './public.scss';

document.cookie = "login_redirect_url=" + encodeURIComponent(window.location.href) + "; path=/";
